import { render, staticRenderFns } from "./AdministrativeActsTaskStatus.vue?vue&type=template&id=5e688582&"
import script from "./AdministrativeActsTaskStatus.vue?vue&type=script&lang=js&"
export * from "./AdministrativeActsTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports